export default "__VITE_ASSET__4QeQqVAUdwGwQIvMHnqk_g__"